export default function RolesManagementSkeleton() {
  return (
    <div className="container animate-pulse p-6">
      <div className="mb-6 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="h-8 w-8 rounded bg-neutralLight" />
          <div className="h-5 w-40 rounded bg-neutralLight" />
        </div>
        <div className="h-10 w-28 rounded-lg bg-neutralLight" />
      </div>

      <div className="mr-3 overflow-y-auto rounded-md border border-gray-200 shadow-sm">
        <table className="w-full table-auto text-sm">
          <thead>
            <tr className="border-b border-gray-200">
              {Array.from({ length: 4 }, (_, index) => (
                <th
                  key={index}
                  className="p-3 text-left"
                >
                  <div className="h-4 w-20 rounded bg-neutralLight" />
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: 6 }, (_, index) => (
              <tr
                key={index}
                className="border-b border-gray-100"
              >
                {Array.from({ length: 4 }, (_, cellIndex) => (
                  <td
                    key={cellIndex}
                    className="p-3"
                  >
                    <div className="h-4 w-24 rounded bg-neutralLight" />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
